<template>
  <!-- 资质列表 -->
  <div>
    <div class="fourthStep">
      <el-form
        ref="extTable"
        :model="{ extTable }"
        :rules="tableRules"
        props
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item class="addTabIndex" label-width="0px" label="" prop="">
          <el-table
            border
            :data="extTable"
            class="ccui-form-child-table"
            max-height="99999"
          >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            fixed>
          </el-table-column>
          <el-table-column prop="attribute3" label="年份" min-width="130px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.attribute3`"
                :rules="tableRules.attribute3"
              >
                <el-date-picker
                  style="width: 110px;"
                  v-model="scope.row.attribute3"
                  type="year"
                  value-format="yyyy"
                  placeholder="请选择年份">
                </el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="200px" prop="firstParty" label="合作方">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.firstParty`"
                :rules="tableRules.firstParty"
              >
                <el-input
                  style="width: 180px"
                  v-model="scope.row.firstParty"
                  placeholder="请输入"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="220px" prop="concName" label="合同名称">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.concName`"
                :rules="tableRules.concName"
              >
                <el-input
                  style="width: 200px"
                  v-model="scope.row.concName"
                  placeholder="请输入"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            width="150px"
            prop="concAmount"
            label="合同金额（万元）"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.concAmount`"
                :rules="tableRules.concAmount"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.concAmount"
                  v-input.float="6"
                  placeholder="请输入"
                  clearable
                  maxlength="21"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="300px" prop="cooPfeInfo" label="主要工作内容">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.cooPfeInfo`"
                :rules="tableRules.cooPfeInfo"
              >
                <el-input
                  style="width: 280px"
                  v-model="scope.row.cooPfeInfo"
                  placeholder="请输入"
                  clearable
                  maxlength="1000"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="contractDuration" label="合同工期（天）">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.contractDuration`"
                :rules="tableRules.contractDuration"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.contractDuration"
                  v-input.float="2"
                  placeholder="请输入"
                  clearable
                  maxlength="6"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="firstPartyWitness" label="甲方证明人">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.firstPartyWitness`"
                :rules="tableRules.firstPartyWitness"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.firstPartyWitness"
                  placeholder="请输入"
                  clearable
                  maxlength="18"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="160px" prop="witnessPhone" label="证明人联系电话">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.witnessPhone`"
                :rules="tableRules.witnessPhone"
              >
                <el-input
                  style="width: 140px"
                  v-model="scope.row.witnessPhone"
                  v-input.phoneNum
                  placeholder="请输入"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="teamLeader" label="现场负责人">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.teamLeader`"
                :rules="tableRules.teamLeader"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.teamLeader"
                  placeholder="请输入"
                  clearable
                  maxlength="18"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="teamLeaderPhone" label="负责人电话">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.teamLeaderPhone`"
                :rules="tableRules.teamLeaderPhone"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.teamLeaderPhone"
                  v-input.phoneNum
                  placeholder="请输入"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="200px" prop="extInfo" label="其他">
            <template slot-scope="scope">
              <el-form-item
              :prop="`extTable.${scope.$index}.extInfo`"
              >
                <el-input
                  style="width: 180px"
                  v-model="scope.row.extInfo"
                  placeholder="请输入"
                  clearable
                  maxlength="255"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="合作业绩证明" width="230">
            <!-- :http-request="(file)=>{return imggreySuccess(file ,scope.row)}" -->
            <template slot-scope="scope">
              <!-- evidenceFile -->
              <!-- {{getUrl(scope)}} -->
              <el-form-item
                :prop="`extTable.${scope.$index}.extInfo`"
              >
                <el-upload
                  class="upload_content"
                  :file-list="scope.row.fileList?scope.row.fileList:[]"
                  :limit="1"
                  :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, scope.row.id)"
                  :action="importFileUrl"
                  :on-remove="(file, fileList) => handleRemove(file, fileList, scope.row.id)"
                >
                  <!-- :show-file-list="false" -->
                  <!-- list-type="text" -->
                  <span
                    v-if="!scope.row.evidenceEnclosure"
                    style="font-size:7px;padding:3px 10px;border-radius:5px;color:white;background:red;"
                    >上传</span
                  >
                  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div> -->
                </el-upload>
              </el-form-item>
            </template>
          </el-table-column>
            <el-table-column prop="remark" label="操作" width="100px" fixed="right">
              <template slot-scope="scope">
                <span
                  style="color: red; cursor: pointer"
                  @click="deleteItem(scope)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label-width="0px" label="">
          <div class="addBtn" @click="addTable()">+添加履约能力</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// import { getBuildingGradeDict } from "@/api/subcontractor-register";
export default {
  props: {
    extTable: {
      type: Array,
      default: []
    }
  },
  components: {
  },
  computed: {
  
  },
  data() {
    return {
      checkOut: false,
      fileList: [],
      tableRules: {
        attribute3: [{ required: true, message: "请选择年份", trigger: "change" }],
        firstParty: [{ required: true, message: "请输入合作方名称", trigger: "blur" }],
        concName: [{ required: true, message: "请输入合同名称", trigger: "blur" }],
        concAmount: [{ required: true, message: "请输入合同金额", trigger: "blur" }],
        cooPfeInfo: [{ required: true, message: "请输入主要工作内容", trigger: "blur" }],
        contractDuration: [{ required: true, message: "请输入合同工期", trigger: "blur" }],
        firstPartyWitness: [{ required: true, message: "请输入甲方证明人", trigger: "blur" }],
        witnessPhone: [{ required: true, message: "请输入证明人联系电话", trigger: "blur" }],
        teamLeader: [{ required: true, message: "请输入现场负责人", trigger: "blur" }],
        teamLeaderPhone: [{ required: true, message: "请输入负责人电话", trigger: "blur" }],
      },
      importFileUrl:
        this.$addUrlPerFix(process.env.VUE_APP_UPLOAD_URL) +
        "/apis/sra/reg/users/signup/uploadFileToOss", // 上传地址
      currentId: "",
    };
  },
  mounted() {
    // getBuildingGradeDict({}).then(res => {
    //   if (res.data.code === "0") {
    //     this.qualificationLevel = res.data.data;
    //   }
    // });
    this.extTable.forEach(item => {
      if(item.evidenceEnclosure){
        item.fileList = [{
          name: item.evidenceEnclosureName?item.evidenceEnclosureName:item.evidenceEnclosure,
          url: item.evidenceEnclosure
        }]
      }
    })
  },
  methods: {
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1
        });
      }
    },
    handleSuccess(response, file, fileList, id) {
      this.extTable.forEach(item => {
        if (id === item.id) {
          item.fileList = [{
            name: response.data[0].fileName,
            url: response.data[0].downloadUrl
          }]
          this.$set(item, "evidenceEnclosure", response.data[0].uploadId);
        }
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    handleRemove(file, fileList, id) {
      this.extTable.forEach(item => {
        if (id === item.id) {
          this.$set(item, "evidenceEnclosure", "");
          delete item.fileList;
        }
      });
    },
    ruleFun() {
      this.$refs["extTable"].validate(valid => {
        if (valid) {
          this.checkOut=  true;
        } else {
          this.$refs.extTable.$el.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          this.checkOut=  false;
        }
      });
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    },
    lastStep() {
      this.$emit("getStep", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-table /deep/th.gutter {
  display: table-cell !important;
}
.addBtn {
  cursor: pointer;
  margin: 20px 0px 10px 0px;
  width: 1006px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}
/deep/ .el-input--suffix .el-input__inner {
  // padding-right: 25px;
}
/deep/ .el-input__suffix {
  // right: 0px;
  .el-input__clear {
    width: 23px;
  }
}
.addTabIndex /deep/.el-table {
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 60px !important;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }

  th>.cell:before{
    content: "*";
    color: red;
    margin-right: 5px;
  }
  th:nth-child(14)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  th:nth-child(13)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  th:nth-child(12)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  th:nth-child(1)>.cell:before{
    content: "";
    margin-right: 5px;
  }
}
.table_title {
  width: 100%;
  line-height: 40px;
  border: 1px solid #EDF2FC;
  border-bottom: 0px;
  box-sizing: border-box;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #f8fafd;
}
.upload_content {
  position: relative;
  // /deep/ .el-upload {
  //   width: 100px;
  //   span {
  //     width: 100px;
  //   }
  // }
  /deep/ .el-upload-list {
    position: absolute;
    top: 0px;
    width: 210px
  }
}


</style>
